(function ($) {
    var halo = {
        imageBannderSlide: function() {
            var imageBanner = $('[data-image-banner-slide]');
            
            imageBanner.each(function() {
                var self = $(this);

                // The section now loads this file itself with defer, so on a page carrying two
                // banner sections it runs twice. Slick has no re-init guard of its own and the
                // autoplayNext() timer below would be started a second time, stepping the same
                // slider twice per tick.
                if (self.hasClass('slick-initialized')) return;

                var arrowEnable = self.data('arrows'),
                    dotEnable = self.data('dots'),
                    autoplay = self.data('autoplay'),
                    autoplaySpeed = self.data('autoplay-speed'),
                    transitionSpeed = self.data('speed')


                // slick initialize
                self.slick({
                   infinite: true,
                    autoplay: autoplay,
                    autoplaySpeed: autoplaySpeed,   
                    speed: transitionSpeed,         
                    arrows: arrowEnable,
                    dots: dotEnable,
                    fade: true,
                    nextArrow: window.arrows.icon_next,
                    prevArrow: window.arrows.icon_prev,
                    rtl: window.rtl_slick,
                });

                // custom autoplay
                var autoplayNext = function() {
                    var currentSlide = self.slick('slickCurrentSlide');
                    var currentDelay = self.find('.slick-slide[data-slick-index="'+ currentSlide +'"]').data('delay') || 5000;
                    
                    setTimeout(function() {
                        self.slick('slickNext');
                        autoplayNext();
                    }, currentDelay);
                };

                autoplayNext(); 
            });
        }
    }
    halo.imageBannderSlide();
})(jQuery);
